// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"212314e6","389":"eefef7d1","453":"985c0bf0","455":"48638cbb","977":"9c89e133"}[chunkId] + ".chunk.js";
};